import React, { useEffect, useState } from "react";
import { Modal, Button, Spin, Divider } from "antd";
import { httpService } from "../../../../../services/httpService.service";
import cancelX from "../../../../../Assets/svg/cancelXbutton.svg";
import "./style.scss";
import { formatDate } from "../../../../../services/helpFunctions/formatDateAndTime";
import {
  getTaskStatus,
  getTaskTypes,
} from "../../../../../services/Enums/taskStatusesEnum";

const PreviewTaskModal = ({ isVisible, onClose, taskId }) => {
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchTaskData = (taskId) => {
    setLoading(true);
    httpService.get(
      `/api/Tasks/getTask?id=${taskId}`,
      (res) => {
        setTask(res.data);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (taskId) {
      fetchTaskData(taskId);
    }
  }, [taskId]);

  const type = task?.type ? Number(task?.type) : null;

  const status = task?.status ? Number(task?.status) : null;

  const { className, fill, text } = getTaskStatus(status);

  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={onClose}
              alt="cancelX"
            />
          </div>
          <h2 className="modalHeader">Preview Task</h2>
        </>
      }
      width={700}
      open={isVisible}
      onCancel={onClose}
      closable={false}
      footer={[
        <Button key="back" className="inviteButtonTPM" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        {task ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            <div>
              <p className="textHeadingTask">Task Card Identifier</p>
              <p className="textParagraphTask">{task?.identifier}</p>
            </div>
            <div>
              <p className="textHeadingTask">Task Name</p>
              <p className="textParagraphTask">{task?.name}</p>
            </div>
            <div>
              <p className="textHeadingTask">Task Type</p>
              <p className="textParagraphTask">{getTaskTypes(type)}</p>
            </div>
            <div>
              <p className="textHeadingTask">Deadline</p>
              <p className="textParagraphTask">{formatDate(task?.deadline)}</p>
            </div>
            <div>
              <p className="textHeadingTask">Site Visit Card</p>
              <p className="textParagraphTask">{task?.taskSite?.identifier}</p>
            </div>
            <div>
              <p className="textHeadingTask">Assigned To</p>

              <div className="userListContainer d-flex flex-column gap-5 mb-4">
                {task?.assignees?.map((member) => (
                  <div key={member.id}>
                    <h1 style={{ fontSize: "16px", margin: "0" }}>
                      {member?.firstName && member?.lastName
                        ? `${member?.firstName} ${member?.lastName}`
                        : member?.email}
                    </h1>
                    <p style={{ fontSize: "12px", margin: "0", color: "gray" }}>
                      {member.roleName || "No role specified"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            {task?.collectionMethod && (
              <div>
                <p className="textHeadingTask">Collection Method</p>
                <p className="textParagraphTask">{task?.collectionMethod}</p>
              </div>
            )}
            {task?.description && (
              <div>
                <p className="textHeadingTask">Task Description</p>
                <p className="textParagraphTask">{task?.description}</p>
              </div>
            )}
            <div>
              <p className="textHeadingTask">Number of Interviews</p>
              <p className="textParagraphTask">{task?.numberOfInterviews}</p>
            </div>
            {task?.additionalNotes && (
              <div>
                <p className="textHeadingTask">Any Additional Notes</p>
                <p className="textParagraphTask">{task?.additionalNotes}</p>
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
                alignSelf: "stretch",
              }}
            >
              <p className="textHeadingTask">Status</p>
              <div
                className={`status-badge ${className}`}
                style={{ display: "flex", alignItems: "center" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8px"
                  height="8px"
                  viewBox="0 0 9 9"
                  style={{ marginRight: "6px" }}
                >
                  <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
                </svg>
                {text}
              </div>
            </div>
          </div>
        ) : (
          <p>Loading task details...</p>
        )}
      </Spin>

      <Divider />
    </Modal>
  );
};

export default PreviewTaskModal;
